const lifehack6 = ($arrow, $sign) => {
	new TimelineMax()
		.to($sign, 6, {
			rotationX: '360deg',
			paused: false,
			repeat: -1,
			ease: Linear.easeNone,
			clearProps: 'true',
		})
		.to($arrow, 3, {
			xPercent: 65,
			paused: false,
			repeat: -1,
			rotationZ: -0.0001,
			ease: Linear.easeNone,
			yoyo: true,
			clearProps: 'true',
		}, 0);
};

export default lifehack6;
